const keyboardDatePickerFormEquipServType = {
  invalidDateMessage: 'Date in invalid format.',
  maxDateMessage: 'The date cannot exceed the limit.'
};

export default keyboardDatePickerFormEquipServType;
